import React, { useState, MouseEvent, useCallback, useEffect } from "react";

import styles from "./ReportCellSlidersDropDown.module.scss";
import { IoClose } from "react-icons/io5";

import { useParams } from "react-router-dom";
import { ScenarioSliders } from "../../extractedComponents/ScenarioManagerWidget/ScenarioSliders";

export interface ReportCellSlidersDropDownProps {
  cellId: string;
  pageId: string;
  onClose: () => void;
  initialPosition: { x: number; y: number };
}

export const ReportCellSlidersDropDown: React.FC<
  ReportCellSlidersDropDownProps
> = ({ cellId, pageId, onClose, initialPosition }) => {
  const [position, setPosition] = useState(initialPosition);
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (isDragging) {
        setPosition({
          x: e.clientX - dragOffset.x,
          y: e.clientY - dragOffset.y,
        });
      }
    },
    [isDragging, dragOffset]
  );

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  const handleMouseDown = (e: MouseEvent) => {
    if ((e.target as HTMLElement).closest(`.${styles.header}`)) {
      setIsDragging(true);
      setDragOffset({
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      });
    }
  };

  useEffect(() => {
    if (isDragging) {
      //@ts-ignore
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      //@ts-ignore
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  return (
    <div
      className={styles.dropdown}
      style={{
        position: "absolute",
        left: `${position.x}px`,
        top: `${position.y}px`,
        cursor: isDragging ? "grabbing" : "grab",
      }}
      onMouseDown={handleMouseDown}
    >
      <div className={styles.header}>
        <span>Choose potential impact</span>
        <IoClose className={styles.close} onClick={onClose} />
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        <ScenarioSliders cellId={cellId!} pageId={pageId!} />
      </div>
    </div>
  );
};
